import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import {
  KeycloakEvent,
  KeycloakEventType,
  KeycloakService,
} from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { from, Subscription } from 'rxjs';
import { UserRoles } from 'src/app/auth/auth.model';
import { ICardList } from 'src/app/model/card-list.model';
import { addMainTheme, removeMainTheme } from 'src/app/shared/utils/utils';
import { RoleService } from '@shared/services/role/role.service';
import { TypeIcon } from '@model/icon.model';
import { IStrumentiUtiliSettings } from '@model/strumenti-utili.model';

const { CALENDAR, CHECK, FOLDER } = TypeIcon;
const { CITTADINO, CPI, DOCENTE, ENTE, PRESIDENTE, REGIONE, TUTOR } = UserRoles;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  nome: string = '';

  userRoles = UserRoles;

  roleCardTitle: string = '';
  welcomeCardDescr: string = '';
  cardListConfig: ICardList[] = [];
  showStrumentiUtili: boolean = false;
  settingsStrumentiUtili: IStrumentiUtiliSettings = {};

  constructor(
    public keycloakSrv: KeycloakService,
    private roleService: RoleService
  ) {}

  ngOnDestroy(): void {
    removeMainTheme();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngAfterViewInit(): void {
    addMainTheme();
  }

  ngOnInit(): void {
    this.setUserName();
    this.keycloakSrv.keycloakEvents$.subscribe((event: KeycloakEvent) => {
      if (event.type == KeycloakEventType.OnAuthSuccess) {
        this.setUserName();
      }
    });
    this.dashboardSettings();
  }

  setUserName() {
    from(this.keycloakSrv.loadUserProfile()).subscribe(
      (profile: KeycloakProfile) => {
        if (profile) {
          this.nome = profile.firstName!;
        }
      }
    );
  }

  dashboardSettings(): void {
    this.subscriptions.push(
      this.roleService.ruoloAttuale.subscribe((ruoloAttuale: string) => {
        this.showStrumentiUtili = false;
        switch (ruoloAttuale as UserRoles) {
          case CPI: {
            this.roleCardTitle = 'ROLE_CPI';
            this.welcomeCardDescr = 'DASH_DESCR_CPI';
            this.cardListConfig = [
              {
                title: 'FIRST_FUNC_CPI_TITLE_CARD',
                description: '',
                icon: FOLDER,
                route: '/servizi/cpi/iscrizione-beneficiari',
              },
            ];
            this.settingsStrumentiUtili = {
              cardTitle: 'HELPFUL_CPI_CARD_TITLE',
              cardBody: 'HELPFUL_CPI_CARD_BODY',
              titleDownloadBtn: 'TITLE_BTN_DOWNLOAD_STRUMENTI_UTILI_CPI',
              userRoles: CPI,
            };
            this.showStrumentiUtili = true;
            break;
          }
          case ENTE: {
            this.roleCardTitle = 'ROLE_ENTE';
            this.welcomeCardDescr = 'DASH_DESCR_ENTE';
            this.cardListConfig = [
              {
                title: 'FUNCT_GEST_OFF_FORM_ODC_TITLE',
                description: '',
                icon: FOLDER,
                route: '/servizi/ente/gestione-offerte-formative',
              },
              {
                title: 'FUNCT_GEST_CLASS_TITLE',
                description: '',
                icon: FOLDER,
                route: '/servizi/ente/gestione-classi',
              },
            ];
            this.settingsStrumentiUtili = {
              cardTitle: 'HELPFUL_TOOLS_CARD_TITLE',
              cardBody: 'HELPFUL_TOOLS_CARD_BODY',
              titleDownloadBtn: 'TITLE_BTN_DOWNLOAD_STRUMENTI_UTILI',
              userRoles: ENTE,
            };
            this.showStrumentiUtili = true;
            break;
          }
          case REGIONE: {
            this.roleCardTitle = 'ROLE_REGIONE';
            this.welcomeCardDescr = 'DASH_DESCR_REGIONE';
            this.cardListConfig = [
              {
                title: 'FUNCT_GEST_CLASS_TITLE',
                description: '',
                icon: FOLDER,
                route: '/servizi/regione/gestione-classi',
              },
            ];
            break;
          }
          case DOCENTE: {
            this.roleCardTitle = 'ROLE_DOCENTE';
            this.welcomeCardDescr = 'DASH_DESCR_DOCENTE';
            this.cardListConfig = [
              {
                title: 'FUNCT_CONFIRM_LESSONS_TITLE',
                description: '',
                icon: CHECK,
                route: '/servizi/docente/lezioni-odierne',
              },
            ];
            break;
          }
          case CITTADINO: {
            this.roleCardTitle = 'ROLE_CITTADINO';
            this.welcomeCardDescr = 'DASH_DESCR_CITTADINO';
            break;
          }
          case PRESIDENTE: {
            this.roleCardTitle = 'PRESIDENTE';
            this.welcomeCardDescr = 'DASH_DESCR_PRESIDENTE';
            this.cardListConfig = [
              {
                title: 'EXAM_CALENDAR',
                description: '',
                icon: CALENDAR,
                route: '/servizi/presidente/calendario-esami',
              },
            ];
            break;
          }
          case TUTOR: {
            this.roleCardTitle = 'TUTOR';
            this.welcomeCardDescr = 'DASH_DESCR_TUTOR';
            this.cardListConfig = [
              {
                title: 'GESTIONE_TIROCINI',
                description: '',
                icon: CALENDAR,
                route: '/servizi/tutor/gestione-tirocini',
              },
            ];
            break;
          }
          default:
            break;
        }
      })
    );
  }
}
